webpackJsonp([213130420965792],{

/***/ 262:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post-heading":"src-styles----post-module---post-heading---3XY_J","post-heading__title":"src-styles----post-module---post-heading__title---1-9YQ","post-heading__meta":"src-styles----post-module---post-heading__meta---3katd","donation":"src-styles----post-module---donation---1rPSR","pager":"src-styles----post-module---pager---3ag2f","pager__item":"src-styles----post-module---pager__item---vNI-Q","pager__title":"src-styles----post-module---pager__title---2ZGsj","pager__tips":"src-styles----post-module---pager__tips---R2YkG","pager__item--disabled":"src-styles----post-module---pager__item--disabled---XSQC6"};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames3 = __webpack_require__(15);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _Tag = __webpack_require__(33);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _postModule = __webpack_require__(257);
	
	var _postModule2 = _interopRequireDefault(_postModule);
	
	__webpack_require__(262);
	
	__webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Share = function (_React$Component) {
	  _inherits(Share, _React$Component);
	
	  function Share() {
	    _classCallCheck(this, Share);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Share.prototype.addShareSupport = function addShareSupport() {
	    var headElement = document.querySelector('head');
	    var linkElement = document.createElement('link');
	
	    linkElement.rel = 'stylesheet';
	    linkElement.href = 'https://cdnjs.cloudflare.com/ajax/libs/social-share.js/1.0.16/css/share.min.css';
	
	    headElement.appendChild(linkElement);
	
	    var scriptElement = document.createElement('script');
	
	    scriptElement.src = 'https://cdnjs.cloudflare.com/ajax/libs/social-share.js/1.0.16/js/social-share.min.js';
	
	    headElement.appendChild(scriptElement);
	  };
	
	  Share.prototype.addHighlightSupport = function addHighlightSupport() {
	    var headElement = document.querySelector('head');
	    var linkElement = document.createElement('link');
	
	    linkElement.rel = 'stylesheet';
	    linkElement.href = 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.11.0/themes/prism-okaidia.min.css';
	
	    headElement.appendChild(linkElement);
	  };
	
	  Share.prototype.componentDidMount = function componentDidMount() {
	    this.addHighlightSupport();
	    this.addShareSupport();
	  };
	
	  Share.prototype.render = function render() {
	    return _react2.default.createElement('div', { className: 'social-share', 'data-disabled': 'diandian' });
	  };
	
	  return Share;
	}(_react2.default.Component);
	
	var Pager = function Pager(_ref) {
	  var _classnames, _classnames2;
	
	  var prev = _ref.prev,
	      next = _ref.next;
	
	  var prevBtnClass = (0, _classnames4.default)((_classnames = {}, _classnames[_postModule2.default.pager__item] = true, _classnames[_postModule2.default['pager__item--prev']] = true, _classnames[_postModule2.default['pager__item--disabled']] = !prev, _classnames));
	
	  var nextBtnClass = (0, _classnames4.default)((_classnames2 = {}, _classnames2[_postModule2.default.pager__item] = true, _classnames2[_postModule2.default['pager__item--next']] = true, _classnames2[_postModule2.default['pager__item--disabled']] = !next, _classnames2));
	
	  return _react2.default.createElement(
	    'ul',
	    {
	      className: _postModule2.default.pager + ' row justify-content-between text-center list-inline'
	    },
	    _react2.default.createElement(
	      'li',
	      { className: 'col list-inline-item' },
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          className: prevBtnClass,
	          to: prev ? '/articles' + prev.fields.slug : null,
	          title: prev ? prev.frontmatter.title : '已经是第一篇啦 ^_^'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: '' + _postModule2.default.pager__title },
	          'Previous'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: '' + _postModule2.default.pager__tips },
	          prev ? prev.frontmatter.title : '已经是第一篇啦 ^_^ '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: 'col list-inline-item' },
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          className: nextBtnClass,
	          to: next ? '/articles' + next.fields.slug : null,
	          title: next ? next.frontmatter.title : '已经是最后一篇啦 ^_^'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: '' + _postModule2.default.pager__title },
	          'Next'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: '' + _postModule2.default.pager__tips },
	          next ? next.frontmatter.title : '已经是最后一篇啦 ^_^'
	        )
	      )
	    )
	  );
	};
	
	var PostTemplate = function PostTemplate(_ref2) {
	  var data = _ref2.data,
	      pathContext = _ref2.pathContext;
	
	  var post = data.markdownRemark;
	  var siteMetadata = data.site.siteMetadata;
	
	
	  var tags = post.frontmatter.tags || [];
	
	  var author = post.frontmatter.author || siteMetadata.defaultAuthor;
	
	  var inlineStyleOfPostHeading = {};
	
	  if (post.frontmatter.cover) {
	    inlineStyleOfPostHeading['backgroundImage'] = 'url(' + post.frontmatter.cover + ')';
	  }
	
	  var pageTitle = post.frontmatter.title + ' - \u7531\u4F5C\u8005' + author + '\u53D1\u5E03\u4E8E ' + post.frontmatter.date;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        pageTitle
	      ),
	      _react2.default.createElement('link', {
	        rel: 'stylesheet',
	        href: 'https://cdn.bootcss.com/github-markdown-css/2.10.0/github-markdown.min.css'
	      }),
	      _react2.default.createElement('meta', { itemprop: 'name', content: pageTitle }),
	      _react2.default.createElement('meta', { itemprop: 'description', content: pathContext.excerpt }),
	      _react2.default.createElement('meta', {
	        itemprop: 'image',
	        content: post.frontmatter.cover || siteMetadata.thumbnail
	      }),
	      _react2.default.createElement('meta', {
	        property: 'og:url',
	        content: siteMetadata.url + '/articles' + pathContext.slug
	      }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: pageTitle }),
	      _react2.default.createElement('meta', { property: 'og:description', content: pathContext.excerpt }),
	      _react2.default.createElement('meta', {
	        property: 'og:image',
	        content: post.frontmatter.cover || siteMetadata.thumbnail
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: pageTitle }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: pathContext.excerpt }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:image',
	        content: post.frontmatter.cover || siteMetadata.thumbnail
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _postModule2.default['post-heading'], style: inlineStyleOfPostHeading },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-md-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tags ghost-tags' },
	              tags.map(function (tag) {
	                return _react2.default.createElement(
	                  _Tag2.default,
	                  { key: tag, to: '/tags#' + tag, theme: 'white', full: true },
	                  tag
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: _postModule2.default['post-heading__title'] },
	              post.frontmatter.title
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _postModule2.default['post-heading__meta'] },
	              author,
	              ' \xB7 ',
	              post.frontmatter.date
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-md-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-10' },
	          _react2.default.createElement('article', {
	            className: 'markdown-body ' + siteMetadata.language,
	            dangerouslySetInnerHTML: { __html: post.html }
	          }),
	          siteMetadata.donation.status && _react2.default.createElement(
	            'div',
	            { className: _postModule2.default.donation },
	            _react2.default.createElement(
	              'h3',
	              { className: 'mb-3' },
	              '\u60A8\u7684\u9F13\u52B1\u662F\u4F5C\u8005\u5199\u4F5C\u6700\u5927\u7684\u52A8\u529B'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5982\u679C\u60A8\u8BA4\u4E3A\u672C\u7F51\u7AD9\u7684\u6587\u7AE0\u8D28\u91CF\u4E0D\u9519\uFF0C\u8BFB\u540E\u89C9\u5F97\u6536\u83B7\u5F88\u5927\uFF0C\u4E0D\u59A8\u8BF7\u6211\u559D\u676F\u5496\u5561\uFF0C\u8BA9\u6211\u6709\u52A8\u529B\u7EE7\u7EED\u5199\u51FA\u9AD8\u8D28\u91CF\u7684\u6587\u7AE0\u3002'
	            ),
	            siteMetadata.donation.channel.alipay && _react2.default.createElement(
	              'a',
	              {
	                href: siteMetadata.donation.channel.alipay,
	                className: 'btn btn-primary mr-2',
	                target: '_blank'
	              },
	              '\u652F\u4ED8\u5B9D\u6253\u8D4F'
	            ),
	            siteMetadata.donation.channel.wechat && _react2.default.createElement(
	              'a',
	              {
	                href: siteMetadata.donation.channel.wechat,
	                className: 'btn btn-success',
	                target: '_blank'
	              },
	              '\u5FAE\u4FE1\u6253\u8D4F'
	            )
	          ),
	          siteMetadata.share && _react2.default.createElement(Share, null),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(Pager, { prev: pathContext.prev, next: pathContext.next })
	        )
	      )
	    )
	  );
	};
	
	exports.default = PostTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-jsx-e43738fb749a9be89f94.js